import posthog from "posthog-js";

export const CONSENT_STORAGE_KEY = "lh_consent";
export const OPEN_BANNER_EVENT = "lh:open-cookie-settings";

export type ConsentDecision = "accepted" | "rejected";

export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export function getConsent(): ConsentDecision | null {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    return value === "accepted" || value === "rejected" ? value : null;
  } catch {
    return null;
  }
}

export function setConsent(decision: ConsentDecision): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, decision);
  } catch {
    // Storage blocked (private mode, quota, etc). Decision lives only for this session.
  }
}

export function applyConsent(decision: ConsentDecision): void {
  if (typeof window === "undefined") return;

  if (GA_MEASUREMENT_ID) {
    const flag = `ga-disable-${GA_MEASUREMENT_ID}`;
    (window as unknown as Record<string, boolean>)[flag] = decision === "rejected";
  }

  if (typeof posthog === "undefined") return;
  if (decision === "rejected") {
    if (posthog.__loaded) posthog.opt_out_capturing();
  } else if (posthog.__loaded) {
    posthog.opt_in_capturing();
  }
}
